export const BoxShadow = '5px 5px 10px 0px rgba(0, 0, 0, 0.69)';
